<template>
  <el-tabs v-model="activeTabName" class="device-detail-tabs">
    <!--    v-if="shadowRole"-->
    <!--    :roleList="shadowRoleList"-->
    <el-tab-pane :label="$t('APPUser.deviceList')" name="first" lazy>
      <Device v-if="activeTabName === 'first'" :tableData="tableData" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import { getRoleByOperationCode, getRoute } from '@/authorized'
import Device from './Device'
export default {
  name: 'index',
  props: {
    tableData: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Device
  },
  created() {},
  data() {
    return {
      activeTabName: 'first'
    }
  },
  computed: {}
}
</script>

<style scoped></style>
